/* eslint-disable no-unused-vars */
import { useEffect, forwardRef } from 'react';
import { SearchIcon, DeleteIcon, Search as SmallSearchIcon } from 'assets/icons';
import { IconButton } from 'components';
import * as S from './Search.styled';
import { useSignal } from '@preact/signals-react';

export const Search = forwardRef(
  (
    {
      width,
      style,
      value,
      placeholder,
      rightIconOnClick,
      onChange,
      disabled,
      isError,
      Icon,
      id,
      onFocus = () => {},
      deleteIconName,
    },
    ref,
  ) => {
    const isHovered$ = useSignal(false);
    const isFocused$ = useSignal(false);
    const showClearButton$ = useSignal(false);

    const handleRightIconClick = () => {
      rightIconOnClick();
      ref.current.focus();
    };

    useEffect(() => {
      showClearButton$.value = value && (isHovered$.value || isFocused$.value);
    }, [isHovered$.value, isFocused$.value, value]);

    return (
      <S.Container
        // ref={ref}
        isError={isError}
        disabled={disabled}
        isHovered={isHovered$.value}
        isFocused={isFocused$.value}
        width={width}
        style={style}
        onMouseEnter={() => {
          isHovered$.value = true;
        }}
        onMouseLeave={() => {
          isHovered$.value = false;
        }}
      >
        <S.LeftIconWrap>
          {Icon ? <Icon /> : <SearchIcon className='SearchIcon' />}
          {/* <SearchIcon className='SearchIcon' /> */}
        </S.LeftIconWrap>
        <S.MyInput
          ref={ref}
          id={id}
          disabled={disabled}
          onChange={onChange}
          type='text'
          value={value}
          placeholder={placeholder}
          onBlur={() => {
            isFocused$.value = false;
          }}
          onFocus={() => {
            isFocused$.value = true;
            onFocus();
          }}
          autoComplete='off'
        />

        {/* {showClearButton$.value && ( */}
        <S.RightBtnWrap
          className={deleteIconName}
          isVisible={disabled ? !disabled : showClearButton$.value}
        >
          <IconButton.SmallSize
            btnSize='24px'
            isDefaultMuted
            icon={DeleteIcon}
            type={IconButton.btnTypes.tertiary}
            onClick={handleRightIconClick}
          />
        </S.RightBtnWrap>
        {/* )} */}
      </S.Container>
    );
  },
);

Search.displayName = 'Search';
